import React, { useState, useEffect } from "react";
import ViewBankInformationStyles from "./ViewBankInformation.styles";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import { Box } from "@mui/system";
import { Grid, Typography } from "@mui/material";
import { useAppSelector } from "../../../../../utils/hooks";
import { selectUserId } from "../../../../../redux/authSlice";
import { getBankDetails } from "../StepperServices";
import {
  isTruthy,
  openErrorNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
}

const ViewBankInformation = (props: CustomProps) => {
  const [bankInfo, setBankInfo] = useState<any>([]);
  const userIdFromRedux = useAppSelector(selectUserId);
  const [apiResponse, setApiResponse] = useState(false);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      setApiResponse(true);
      const response = await getBankDetails(userIdFromRedux);
      customErrorHandler(response);
      setBankInfo(response.data);
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const classes = ViewBankInformationStyles;
  return (
    <>
      <Box sx={classes.contentWrapper}>
        <Box sx={classes.pageInfoHeader}>
          <Typography sx={classes.Heading}>Bank Information</Typography>
          <Typography sx={classes.text}>
            Update your Bank information for the platform
          </Typography>
        </Box>
        <Grid container>
          <Box sx={classes.profileDetails}>
            <Grid container rowSpacing={3}>
              <Grid item xs={12}>
                <Typography sx={classes.detailsHeading}>
                  Bank Details
                </Typography>
                <Typography sx={classes.subHeading}>
                  Manage your bank information to use the platform
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Bank Name</Typography>
                <Typography sx={classes.userDetails}>
                  {bankInfo?.bank_name}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Branch Name</Typography>
                <Typography sx={classes.userDetails}>
                  {bankInfo?.branch_name}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>
                  Account Holder Name
                </Typography>
                <Typography sx={classes.userDetails}>
                  {bankInfo?.holder_name}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Account Number</Typography>
                <Typography sx={classes.userDetails}>
                  {bankInfo?.account_no}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>IFSC Code</Typography>
                <Typography sx={classes.userDetails}>
                  {bankInfo?.ifsc}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Grid item xs={4}>
            <Box sx={classes.buttonWarapper}>
              <CustomButton
                label="Back"
                buttonType="secondaryBtn"
                onClick={() => {
                  props.backStep?.();
                }}
              />
              <CustomButton
                label="Next"
                buttonType="primaryBtn"
                onClick={() => {
                  props.nextStep?.();
                }}
              />
            </Box>
          </Grid>
        </Grid>
        {apiResponse && <CustomLoader apiResponse={false} />}
      </Box>
    </>
  );
};

export default ViewBankInformation;
